module.exports = __webpack_public_path__ + "static/ip-ikon6-893cc0dcfd6649980ea41075795144c1.png";